import { useEffect, useState } from 'react';

import { rulesApi } from '../../api/rules.js';
import { SearchableSelect } from '../../components/ui/SearchableSelect.jsx';
import { PRICE_LEVELS } from '../../constants/priceLevels.js';

const INPUT_STYLE = { width: '100%', padding: 4, fontSize: 12 };

export function PayCodeAddForm({ onSave, onCancel }) {
  const [form, setForm] = useState({
    pay_code_name: '',
    pay_category_name: '',
    ignore_for_billing: false,
    count_towards_ot: '',
    nb_hours_ot_eligible: '',
    special_hol_mapping: false,
    default_price_level: '',
    apply_billing_rules: true,
  });
  // Distinct pay categories Dayforce actually sends (df.pay_summaries) — the
  // engine matches rules on these exact names.
  const [payCategories, setPayCategories] = useState([]);
  useEffect(() => {
    rulesApi.getDistinctPayCategories().then(setPayCategories).catch(() => {});
  }, []);
  const set = (k, v) => setForm((prev) => ({ ...prev, [k]: v }));
  const categoryOptions = payCategories.map((c) => ({ value: c, label: c }));

  return (
    <div style={{
      background: '#fffde7', border: '1px solid #ffd54f',
      borderRadius: 8, padding: 16, marginBottom: 16,
    }}>
      <div style={{ fontWeight: 600, marginBottom: 12 }}>Add New Pay Code Rule</div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: '8px 16px' }}>
        <div>
          <label style={{ fontSize: 11 }}>Pay Code Name *</label>
          <input value={form.pay_code_name} onChange={(e) => set('pay_code_name', e.target.value)} style={INPUT_STYLE} />
        </div>
        <div>
          <label style={{ fontSize: 11 }}>Pay Category Name</label>
          <SearchableSelect
            options={categoryOptions}
            value={form.pay_category_name}
            onChange={(v) => set('pay_category_name', v)}
            placeholder="Search pay categories..."
            renderOption={(o) => o.label}
            width="100%"
          />
        </div>

        <div>
          <label style={{ fontSize: 11 }}>Price Level</label>
          <select value={form.default_price_level} onChange={(e) => set('default_price_level', e.target.value)} style={INPUT_STYLE}>
            <option value="">—</option>
            {PRICE_LEVELS.map((pl) => <option key={pl} value={pl}>{pl}</option>)}
          </select>
        </div>
        <div>
          <label style={{ fontSize: 11 }}>Count Towards OT</label>
          <select value={form.count_towards_ot} onChange={(e) => set('count_towards_ot', e.target.value)} style={INPUT_STYLE}>
            <option value="">—</option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
            <option value="Yes (Worked Only)">Yes (Worked Only)</option>
          </select>
        </div>
        <div>
          <label style={{ fontSize: 11 }}>NB Hours OT Eligible</label>
          <select value={form.nb_hours_ot_eligible} onChange={(e) => set('nb_hours_ot_eligible', e.target.value)} style={INPUT_STYLE}>
            <option value="">—</option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
            <option value="Yes (Worked Only)">Yes (Worked Only)</option>
          </select>
        </div>
        <div style={{ display: 'flex', gap: 16, alignItems: 'center', paddingTop: 16 }}>
          <label style={{ fontSize: 12 }}>
            <input type="checkbox" checked={form.ignore_for_billing}
                   onChange={(e) => set('ignore_for_billing', e.target.checked)} />
            {' '}Exclude for Billing
          </label>
          <label style={{ fontSize: 12 }}>
            <input type="checkbox" checked={form.special_hol_mapping}
                   onChange={(e) => set('special_hol_mapping', e.target.checked)} />
            {' '}Special HOL
          </label>
          <label style={{ fontSize: 12 }}>
            <input type="checkbox" checked={form.apply_billing_rules}
                   onChange={(e) => set('apply_billing_rules', e.target.checked)} />
            {' '}Apply Rules
          </label>
        </div>
      </div>

      <div style={{ marginTop: 12, display: 'flex', gap: 8 }}>
        <button
          className="btn btn-sm btn-success"
          onClick={() => onSave(form)}
          disabled={!form.pay_code_name}
        >
          Save
        </button>
        <button className="btn btn-sm" onClick={onCancel}>Cancel</button>
      </div>
    </div>
  );
}
